<!-- 首页//告警统计  -->
<template>
  <div class="box">
    <Title :text="home.AlarmStatistics.Title[0]" :engText="home.AlarmStatistics.Title[1]"></Title>
        <div class="echarts-content">
          <chart-block ref="a"></chart-block>
        </div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['home']) 
  },
  mounted () {
      this.$refs.a.setOption(this.home.AlarmStatistics.option);
  },
}
</script>

<style scoped>
.box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>